import React from 'react';
import { Alert } from 'react-bootstrap';

const ErrorAlert = ({ error }) => {
  if (!error) return null;
  const message = typeof error === 'string' ? error : error?.message || 'Произошла ошибка';

  return (
    <Alert variant="danger" className="mb-3">
      {message}
    </Alert>
  );
};

export default ErrorAlert;

